import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { AdminMultimediaGridFilter } from '../../models/admin-multimedia-grid-filter';
import { Nillable } from '@web/utils';

@Injectable()
export class MultimediaGridService {
  private readonly filterSource$ = new Subject<AdminMultimediaGridFilter>();
  private readonly loadSource$ = new Subject<
    Nillable<AdminMultimediaGridFilter>
  >();
  private readonly refreshSource$ = new Subject<void>();

  public get filter$(): Observable<AdminMultimediaGridFilter> {
    return this.filterSource$.asObservable();
  }

  public get load$(): Observable<Nillable<AdminMultimediaGridFilter>> {
    return this.loadSource$.asObservable();
  }

  public get refresh$(): Observable<void> {
    return this.refreshSource$.asObservable();
  }

  public filter(filter: AdminMultimediaGridFilter): void {
    this.filterSource$.next(filter);
  }

  public load(filter?: AdminMultimediaGridFilter): void {
    this.loadSource$.next(filter);
  }

  public refresh(): void {
    this.refreshSource$.next();
  }
}
